import { createClient } from '@supabase/supabase-js';
import { instrumentedFetch } from '@/lib/observability';

// Create a single supabase client for interacting with your database
//
// `instrumentedFetch` vive en un módulo `'use client'`. Importado desde el grafo
// del servidor, React NO entrega la función real sino una *client reference*:
// llamarla en RSC/SSR lanza. Como Supabase la invoca en cada query, pasarla en
// el servidor rompía TODA lectura hecha con este cliente (fichas de vehículos y
// enlaces internos quedaban vacíos para los crawlers, mientras el navegador —que
// sí tiene la función real— seguía funcionando; el fallo era invisible porque los
// callers hacen catch). Por eso solo se instrumenta en el browser.
const browserOnlyOptions =
  typeof window === 'undefined'
    ? undefined
    : {
        // Reporta a PostHog toda respuesta no-2xx y toda falla de red desde un
        // solo punto.
        global: { fetch: instrumentedFetch },
      };

export const supabase = createClient(
  process.env.NEXT_PUBLIC_SUPABASE_URL as string,
  process.env.NEXT_PUBLIC_SUPABASE_KEY as string,
  browserOnlyOptions
);
